import React, { Component } from "react";

class Loader extends Component {

    constructor(props){
        super(props);
    }

    render() {

        return (
            this.props.isFetching && 
            <div className="fullBG">
              <div className="uil-ring-css"><div />
            </div>
          </div>
        );
    }
}

export default Loader;


// WEBPACK FOOTER //
// ./src/Components/component_Loader.js